<template>
  <div class="w-full relative" @click.stop>
    <div
      v-if="timelineData.length > 0"
      class="w-full absolute bg-white top-100 z-500 border p-3 overflow-auto height"
      :class="{ hidden: !activePoper }"
    >
      <vx-timeline :data="timelineData" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import VxTimeline from "@/serviforms/designer/components/timeline";
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    activePoper: {
      type: Boolean,
      required: true
    },
    timelineData: {
      type: Array,
      required: true
    }
  },
  components: {
    VxTimeline
  },
  mounted() {
    const html = document.querySelector("html");
    html.addEventListener("click", () => {
      this.$emit("update:active", false);
    });
  },
 
};
</script>

<style lang="scss" scoped>
.height {
  height: auto;
  max-height: 250px !important;
}
.top-100 {
  bottom: 40px;
}
.z-500 {
    z-index: 500!important;
}
</style>
